













import VueOptions from '@utils/VueOptions'
import FormFieldSelect from './FormFieldSelect'

settings =
  name: 'FormFieldTimePicker'

  vue:
    props: ['value', 'errors', 'placeholder', 'filterable', 'disabled']

    data: ->
      value_: @value

    components: {
      FormFieldSelect,
    }

    computed:
      _filterable: ->
        return @filterable if @filterable?
        true

      timeOptions: ->
        startTime = '05:30'
        endTime = '23:30'
        interval = 30

        times = []
        start = new Date("2000-01-01T#{startTime}")
        end = new Date("2000-01-01T#{endTime}")

        while (start <= end)
          t = dayjs(start).format('h:mm A')
          times.push { label: t, value: t }
          start.setMinutes(start.getMinutes() + interval)

        times

    methods:
      hiInputChange: (value) ->
        @$emit 'input', value
        @$emit 'change', value

export default VueOptions.vue settings
